import React, { useEffect, useState } from "react";
import { LineChart, Line, ResponsiveContainer, CartesianGrid } from "recharts";

// datapoints / frequency = time
// 7200 / 240 = 30s
// 0.2s 一格

const getVP = (freq, datapoints) => {
  const total_time = datapoints / freq
  // 30s / 0.2s = 总格数  100% / 总格子数 = 1格的百分比
  const arr = [];
  for (let i = 0; i <= 100; i += 100 / (total_time / 0.2)) {
    let num = i.toFixed(2);
    arr.push(num + "%");
  }
  return arr;
};

const getHP = () => {
  const arr = [];
  for (let i = 0; i <= 100; i += 10) {
    let num = i.toFixed(2);
    arr.push(num + "%");
  }
  return arr;
};

export default function Plot(props) {
  const { groundTruth, contents, frequency, color, height } = props;
  const [fileContent, setFileContent] = useState("");
  useEffect(() => {
    // let content = contents.split(",");
    let content = contents.map((str) => {
      return { pv: parseFloat(str) };
    });
    setFileContent(content);

  }, [contents]);

  const handleMouseEnter = (e) => {
    // do nothing
  };

  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={fileContent} onMouseEnter={handleMouseEnter}>
        <CartesianGrid
          strokeDasharray="solid"
          horizontalPoints={getHP()}
          verticalPoints={getVP(frequency, contents.length)}
          style={{ opacity: props.grid }}
        />
        <Line
          type="monotone"
          dataKey="pv"
          dot={false}
          stroke={
            color
              ? color
              : groundTruth === -1
                ? "#367fff"
                : groundTruth === 0
                  ? "rgb(255, 71, 71)"
                  : "rgb(54, 172, 54)"
          }
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
